import React from 'react'

import Vertical from '../layouts/Vertical.jsx'
import Grid from '../components/Grid.jsx'
import Card from '../components/Card.jsx'
import BlockImageLabelData from '../components/BlockImageLabelData.jsx'
import LoadingState from '../components/LoadingState.jsx'

import femaleCircleIcon from '_static/img/audience-insights/icons/female-circle.png'
import maleCircleIcon from '_static/img/audience-insights/icons/male-circle.png'

import { getGenderDistribution, getAgeDistribution } from '_services/insights-v2.js'
import useRequest from '../hooks/useRequest.js'

import AgeDistributionHOC from '../charts/AgeDistributionHOC.jsx'
import { roundObj } from '../../helpers/roundObj.js'
import { AGES_MAP } from '../../charts/helpers/formatters.js'

const formatAge = (data) => {
  if (!data) return null
  return Object.entries(AGES_MAP).map(([key, name]) => ({ key: name, value: data[key] }))
}

const BASE_GENDER = {
  male: '0',
  female: '0',
}

const AudienceOverview = (props) => {
  const {
    audience: { _id: audienceId },
  } = props
  const { title, description, section_1, section_2 } = props.data

  const { data: genderData, loading: genderLoading } = useRequest(
    getGenderDistribution,
    { audienceId, timeRange: null },
    true
  )
  const genderRounded = roundObj({ ...BASE_GENDER, ...genderData })

  const { data: ageData, loading: ageLoading } = useRequest(
    getAgeDistribution,
    { audienceId, timeRange: null },
    true
  )
  const ageRounded = roundObj(ageData)
  const ageFormatted = formatAge(ageRounded)

  return (
    <Vertical
      title={title}
      description={description}
      page={props.index + 1}
      content={() => (
        <Grid
          direction="horizontal"
          gap={48}
          items={[
            {
              component: (
                <Card title={section_1.title} description={section_1.subtitle} showBorder={true}>
                  <Choose>
                    <When condition={genderLoading}>
                      <LoadingState />
                    </When>
                    <Otherwise>
                      <Grid
                        direction="horizontal"
                        gap={48}
                        items={[
                          {
                            component: (
                              <BlockImageLabelData
                                imageUrl={femaleCircleIcon}
                                label={'FEMALE'}
                                data={`${genderRounded.female}%`}
                              />
                            ),
                            size: 0.5,
                          },
                          {
                            component: (
                              <BlockImageLabelData
                                imageUrl={maleCircleIcon}
                                label={'MALE'}
                                data={`${genderRounded.male}%`}
                              />
                            ),
                            size: 0.5,
                          },
                        ]}
                      />
                    </Otherwise>
                  </Choose>
                </Card>
              ),
              size: 0.4,
            },
            {
              component: (
                <Card title={section_2.title} description={section_2.subtitle} showBorder={true}>
                  {ageLoading ? <LoadingState /> : <AgeDistributionHOC data={ageFormatted} />}
                </Card>
              ),
              size: 0.6,
            },
          ]}
        />
      )}
    />
  )
}

export default AudienceOverview
